import { useEffect, useRef, useState } from "react";
import { useLocation } from "react-router-dom";
import { Dialog, DialogContent, DialogTitle, DialogDescription } from "@/components/ui/dialog";
import { HolidayOffer } from "./HolidayOffer";

const SESSION_KEY = "rcf_holiday_promo_seen";
let shownInMemory = false;
const wasSeen = () => { try { return shownInMemory || !!sessionStorage.getItem(SESSION_KEY); } catch { return shownInMemory; } };
const remember = () => { shownInMemory = true; try { sessionStorage.setItem(SESSION_KEY, "1"); } catch { /* storage may be blocked */ } };

export const PromoPopup = () => {
  const [open, setOpen] = useState(false);
  const { pathname } = useLocation();
  const previousFocus = useRef(null);
  const isAdmin = pathname.startsWith("/admin");
  useEffect(() => {
    if (isAdmin) return;
    const show = () => { previousFocus.current = document.activeElement; remember(); setOpen(true); };
    window.addEventListener("rcf:open-deals", show);
    const timer = !wasSeen() ? setTimeout(show, 15000) : null;
    return () => { clearTimeout(timer); window.removeEventListener("rcf:open-deals", show); };
  }, [isAdmin]);
  if (isAdmin) return null;
  return (
    <Dialog open={open} onOpenChange={setOpen}>
      <DialogContent data-testid="holiday-deals-popup" closeTestId="promo-close" onCloseAutoFocus={event => { event.preventDefault(); previousFocus.current?.focus(); }} className="holiday-dialog max-h-[calc(100dvh-32px)] w-[calc(100%-32px)] max-w-[620px] gap-0 overflow-y-auto rounded-lg border-0 p-0" data-lenis-prevent>
        <DialogTitle className="sr-only" data-testid="holiday-dialog-title">Christmas & New Year flight deals</DialogTitle>
        <DialogDescription className="sr-only">Explore featured flight fares and call our travel team to check your holiday dates.</DialogDescription>
        <HolidayOffer onClose={() => setOpen(false)} />
      </DialogContent>
    </Dialog>
  );
};